import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { AddMultiLedgerAssociationRequestDto } from "../models/multi-ledger/addMultiLedgerAssociationRequestDto";
import { GetMultiLedgerAssociations } from "../models/multi-ledger/getMultiLedgerAssociations";
import { MultiLedgerAssociation } from "../models/multi-ledger/multiLedgerAssociation";
import { AddManagerNotesRequestDto } from "../models/dashboard-poc/addManagerNotesRequestDto";
import { BacDashboardDto } from "../models/dashboard-poc/bacDashboardDto";
import { BacDashboardInformationRequest } from "../models/dashboard-poc/bacDashboardInformationRequest";
import { BilledOrdersYtdResponse } from "../models/dashboard-poc/billedOrdersYtdResponse";
import { GetManagerReportPdfRequest } from "../models/dashboard-poc/getManagerReportPdfRequest";
import { ManagerReportNotes } from "../models/dashboard-poc/managerReportNotes";
import { RollingTwelveMonthDto } from "../models/dashboard-poc/rollingTwelveMonthDto";
import { Q3ReportLocationWiseBcReportDto } from "../models/dashboard-poc/q3ReportLocationWiseBcReportDto";
import { Q3SecondGridReportLocationWiseBcReportDto } from "../models/dashboard-poc/q3SecondGridReportLocationWiseBcReportDto";

@Injectable({
  providedIn: "root",
})
export class DashboardPocService {
  private dashboardPocBaseURL = environment.baseUrl + "/DashboardPoc";

  constructor(private _http: HttpClient) {}

  GetSalesOrderBacInformationForCharts(
    payload: BacDashboardInformationRequest
  ): Observable<GenericResponseDto<BacDashboardDto>> {
    return this._http.post<GenericResponseDto<BacDashboardDto>>(
      `${this.dashboardPocBaseURL}/GetSalesOrderBacInformationForCharts`,
      payload
    );
  }

  GetSalesOrderBacInformationForChartsSupportDashboard(
    payload: BacDashboardInformationRequest
  ): Observable<GenericResponseDto<BacDashboardDto>> {
    return this._http.post<GenericResponseDto<BacDashboardDto>>(
      `${this.dashboardPocBaseURL}/GetSalesOrderBacInformationForChartsSupportDashboard`,
      payload
    );
  }

  getBilledOrdersYTD(
    payload: BacDashboardInformationRequest
  ): Observable<GenericResponseDto<BilledOrdersYtdResponse[]>> {
    return this._http.post<GenericResponseDto<BilledOrdersYtdResponse[]>>(
      `${this.dashboardPocBaseURL}/GetBilledOrdersYTD`,
      payload
    );
  }

  getManagerReportPdf(
    payload: GetManagerReportPdfRequest
  ): Observable<GenericResponseDto<string>> {
    return this._http.post<GenericResponseDto<string>>(
      `${this.dashboardPocBaseURL}/GetManagerReportPdf`,
      payload
    );
  }

  getBilledOrdersYTDSupportDashboard(
    payload: BacDashboardInformationRequest
  ): Observable<GenericResponseDto<BilledOrdersYtdResponse[]>> {
    return this._http.post<GenericResponseDto<BilledOrdersYtdResponse[]>>(
      `${this.dashboardPocBaseURL}/GetBilledOrdersYTDSupportDashboard`,
      payload
    );
  }

  rollingTwelveMonth(
    personnelNumber: string
  ): Observable<GenericResponseDto<RollingTwelveMonthDto>> {
    return this._http.get<GenericResponseDto<RollingTwelveMonthDto>>(
      `${this.dashboardPocBaseURL}/RollingTwelveMonth?personnelNumber=${personnelNumber}`
    );
  }

  getQ3ReportLocationWiseBcReport(
    personnelNumber = ""
  ): Observable<GenericResponseDto<Q3ReportLocationWiseBcReportDto[]>> {
    return this._http.get<
      GenericResponseDto<Q3ReportLocationWiseBcReportDto[]>
    >(
      `${this.dashboardPocBaseURL}/GetQ3ReportLocationWiseBcReport?personnelNumber=${personnelNumber}`
    );
  }

  getQ3SecondGridReportLocationWiseBcReport(
    personnelNumber = ""
  ): Observable<
    GenericResponseDto<Q3SecondGridReportLocationWiseBcReportDto[]>
  > {
    return this._http.get<
      GenericResponseDto<Q3SecondGridReportLocationWiseBcReportDto[]>
    >(
      `${this.dashboardPocBaseURL}/GetQ3SecondGridReportLocationWiseBcReport?personnelNumber=${personnelNumber}`
    );
  }

  AddOrUpdateManagerNotes(
    payload: AddManagerNotesRequestDto
  ): Observable<GenericResponseDto<ManagerReportNotes>> {
    return this._http.post<GenericResponseDto<ManagerReportNotes>>(
      `${this.dashboardPocBaseURL}/AddOrUpdateManagerNotes`,
      payload
    );
  }

  getMultiLedgerAssociations(
    bcPersonnelNumber: string
  ): Observable<GenericResponseDto<GetMultiLedgerAssociations[]>> {
    return this._http.get<GenericResponseDto<GetMultiLedgerAssociations[]>>(
      `${this.dashboardPocBaseURL}/GetMultiLedgerAssociations?bcPersonnelNumber=${bcPersonnelNumber}`
    );
  }

  addMultiLedgerAssociation(
    payload: AddMultiLedgerAssociationRequestDto
  ): Observable<GenericResponseDto<MultiLedgerAssociation>> {
    return this._http.post<GenericResponseDto<MultiLedgerAssociation>>(
      `${this.dashboardPocBaseURL}/AddMultiLedgerAssociation`,
      payload
    );
  }

  deleteMultiLedgerAssociation(
    payload: number[]
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      `${this.dashboardPocBaseURL}/DeleteMultiLedgerAssociation`,
      payload
    );
  }
}
